// AI Generated Component
import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';

@Component({
    selector: 'form-domain-scan-login-types-office365',
    templateUrl: './form-domain-scan-login-office365.component.html',
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
    standalone: false,
})
export class FormDomainScanLoginOffice365Component implements OnInit {
    @Input() login: any = {};
    @Output() loginChange = new EventEmitter<any>();

    ngOnInit () {
        this.activate();
    }

    activate () {
        this.login = this.login || {};
        if (this.login.office365 === null || typeof this.login.office365 !== 'object') {
            this.login.office365 = {};
        }
        this.loginChange.emit(this.login);
    }
}
